import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/responsive.css';
import Home from './components/Home';
import TermsOfUse from './components/TermsOfUse';
import PrivacyPolicy from './components/PrivacyPolicy';
import ChildSafety from './components/ChildSafety';
import SafetyTips from './components/SafetyTips';
import FAQ from './components/FAQ';
import CookiePolicy from './components/CookiePolicy';
import NotFound from './components/NotFound';
import ScrollToTop from './components/ScrollToTop';
import AnimatedBackground from './components/AnimatedBackground';
import CookieBanner from './components/CookieBanner';

function App() {
  return (
    <Router>
      <div className="relative min-h-screen">
        <AnimatedBackground />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/child-safety" element={<ChildSafety />} />
          <Route path="/safety-tips" element={<SafetyTips />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieBanner />
      </div>
    </Router>
  );
}

export default App;
